import React from 'react';

import './MayBeOneImg.scss';
// const imageUtil = require("../../utils/image");
import imageUtil from '../../utils/image';
import { IImageMayBe } from '../../global';
interface IMayBeOneImg {
  maybe: IImageMayBe;
  active: boolean;
  onClick: (url?:string) => void;
}

export const getFaceUrl = (maybe: IImageMayBe) => {
  const { hash, id } = maybe.image;
  let { shape = {} } = maybe;
  // 兼容某些情况下这个是个string的情况
  if (typeof shape === 'string') {
    try {
      shape = JSON.parse(shape);
    } catch (e) {}
  }
  const theUrl = imageUtil.style(
    hash,
    'face',
    {
      shape,
      webp:true
    },
    id
  );

  return theUrl;
};

export default (props: IMayBeOneImg) => {
  const { active, maybe } = props;
  const theUrl = getFaceUrl(maybe);
  return (
    <div
      className={'maybe-one-wrapper ' + (active ? 'active' : '')}
      onClick={()=>{
        if(props.onClick) {
          props.onClick(theUrl);
        }
      }}
    >
      <div
        className={'maybe-one-real-img'}
        style={{ backgroundImage: `url(${theUrl})` }}
      />
    </div>
  );
};
